module.exports = __webpack_public_path__ + "img/mandil_2.a0d3c471.png";